import Vue from 'vue';
import App from './App.vue'; // Import your root component
import i18n from './internationalization/i18n';

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount('#app');
// };
